import { Flex, VStack } from '@talos/kyoko';
import styled from 'styled-components';

export const IndividualOrderBookWrapper = styled(VStack)``;
IndividualOrderBookWrapper.defaultProps = {
  h: '100%',
  flex: '1 1 33%',
  gap: 'spacing4',
  justifyContent: 'flex-start',
  overflow: 'hidden',
  position: 'relative',
  background: 'backgroundContent',
};

export const IndividualOrderBookContent = styled(Flex)``;
IndividualOrderBookContent.defaultProps = {
  w: '100%',
  h: '100%',
  position: 'absolute',
  flexDirection: 'column',
  overflow: 'hidden',
};

export const OrderBookWrapper = styled(Flex)``;
OrderBookWrapper.defaultProps = {
  flex: '1 1 0%',
  overflow: 'hidden',
};

export const IndividualOrderBookHeader = styled(Flex)``;
IndividualOrderBookHeader.defaultProps = {
  h: '40px',
  justifyContent: 'space-between',
  alignItems: 'center',
  px: 'spacing12',
  borderBottom: 'solid 1px',
  borderColor: 'backgroundBody',
  flex: '0 0 auto',
};
